import { FC } from "react";

import { DonorAssistantWidget } from "./DonorAssistantWidget";

import { RouteType } from "@/common/hooks/amplitude/useLogRouteChangePageVisits";
import { useChatWidgetRoute } from "@/components/ChatWidgetVisibilityManager/helpers/useChatWidgetRoute";
import { useChatWidgetSuppressed, useSuppressChatWidget } from "@/common/hooks/useChatWidgetSuppression";
import { useDonorSupportChannel } from "@/components/ChatWidgetVisibilityManager/helpers/useDonorSupportChannel";
import { usePublishDonorSupportChannel } from "@/components/ChatWidgetVisibilityManager/helpers/usePublishDonorSupportChannel";
import { useLogForethoughtWidgetOpened } from "@/components/ChatWidgetVisibilityManager/useLogForethoughtWidgetOpened";
import { useLogAssistantWidgetEvents } from "@/features/Assistant/Widget/helpers/useLogAssistantWidgetEvents";

export const DonorAssistantWidgetGate: FC = () => {
  const { isClientReady, pathWithoutLocale, isHiddenByRoute } = useChatWidgetRoute();
  const resolution = useDonorSupportChannel(pathWithoutLocale);
  const suppressed = useChatWidgetSuppressed();
  const events = useLogAssistantWidgetEvents({
    feature: "donor-assistant",
    routeType: RouteType.DonorRoute,
    path: pathWithoutLocale,
  });

  usePublishDonorSupportChannel({
    resolution,
    path: pathWithoutLocale,
    enabled: isClientReady && resolution.routeType === RouteType.DonorRoute,
  });

  useSuppressChatWidget(resolution.channel !== "forethought");

  useLogForethoughtWidgetOpened({
    enabled: isClientReady && !isHiddenByRoute && !suppressed && resolution.channel === "forethought",
    path: pathWithoutLocale,
  });

  if (resolution.channel !== "assistant" || isHiddenByRoute) {
    return null;
  }

  return <DonorAssistantWidget {...events} />;
};
